import script from "./StatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusBadge.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=a8bf7b42&scoped=true&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-a8bf7b42"]])

export default __exports__